export default __webpack_public_path__ + "static/media/61.0ce61240.jpg";